// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2hJip","title":"BackImages_title__1NZ6G","images":"BackImages_images__2HUKe"};